<template>
  <div>

    <div class="head_box">
      <div class="nav">
        <div class="logo_box">
          <img src="img/logo.png" alt="" />
        </div>

        <div class="two">
          <div class="btn_box">
            <a class="home_box" href="https://taiwanngo.tw/" target="_blank">
              NGO首頁
            </a>
          </div>
        </div>
      </div>

      <div class="banner">
        <div class="title">
          <h1>{{ title_1 }}</h1>
          <h1>{{ title_2 }}</h1>
          <div class="title_line"></div>
        </div>

        <div class="text_box">
          <p>
            <span>
              完成題目 <br class="br" />
              抽AirPods無線耳機與禮券！</span>
          </p>
          <div class="img_box" @click="scrollToSection">
            <img src="img/icon_gift.svg" alt="" />
          </div>
        </div>

        <img class="butterfly" src="img/icon_butterfly.svg" alt="" />
        <img class="earth" src="img/icon_earth.svg" alt="" />

        <img class="rings" src="img/icon_rings.svg" alt="" />
        <img class="clouds" src="img/icon_clouds.svg" alt="" />
        <img class="sun" src="img/icon_sun.svg" alt="" />
        <img class="windmill" src="img/ixon_windmill.svg" alt="" />
        <img class="pads" src="img/icon_pads.svg" alt="" />
      </div>
    </div>

    <div class="activity_box" ref="targetSection">
      <div></div>

      <div class="activity">
        <div class="title">
          <p>活動一</p>
          <p>課前小測驗</p>
          <img src="img/icon_leaf.svg" alt="" />
        </div>

        <div class="text_box">
          <p>
            今年是聯合國公布「永續發展目標」(SDGs)十週年，為配合我國「總合外交」政策，本培訓班以「總合外交政策下我國NGO國際參與成果與展望」為主題，針對NGO外交、城市外交、運動外交、智庫外交及醫衛外交等議題安排講座及焦點座談，並探討SDGs實踐與媒體素養等議題，邀請NGO夥伴及有興趣的民眾報名參加。
            <br />
            本次，我們準備了課前小測驗，完成挑戰題目即可獲得抽獎資格！歡迎您參加本次活動及課程，與我們一同探索和學習。
          </p>
        </div>

        <div class="prize_box text_box">
          <div class="title_box">
            <p>活動期間</p>
          </div>

          <div class="prize date">
            <p>即日起 ~ 12月28日</p>
            <p></p>
          </div>

          <div class="title_box">
            <p>活動獎品</p>
          </div>

          <div class="prize">
            <p>Apple AirPods 4</p>
            <p>1<span>名</span></p>
          </div>

          <div class="prize">
            <p>Edenred 好禮即享券1,000元</p>
            <p>4<span>名</span></p>
          </div>

          <div class="prize">
            <p>Edenred 好禮即享券 500元</p>
            <p>2<span>名</span></p>
          </div>

          <p class="small">
            抽獎公布： 115年1月7日(星期三)在NGO雙語網站公布，並Email通知得獎者。
          </p>
        </div>
      </div>

      <div></div>
    </div>

    <div class="line full">
      <div>【 測驗開始 】</div>
    </div>

    <div class="question_box">
      <div class="question" v-for="(question, index) in questions" :key="index">
        <div class="title">
          <p>{{ index + 1 }}. {{ question.text }}</p>

          <div class="hint_box">
            <button class="hint_btn" :class="{ active: activeHint === index }" @click="showHint(index)"
              :style="activeHint === index ? { width: hintWidth + 'px' } : {}">
              <span v-if="activeHint === index">
                {{ typedHint }}
              </span>
              <span v-else> 小提示！ </span>
            </button>
          </div>
        </div>

        <div class="question_option" v-for="(option, i) in question.options" :key="i">
          <input type="radio" :id="'question_' + index + i" :name="'question_' + index" :value="option"
            v-model="userAnswers[index]" @change="handleChange" :disabled="isSubmitted" />
          <label :for="'question_' + index + i">
            {{ option }}
          </label>
        </div>
      </div>

      <div class="result_box">
        <div v-if="result === 'success'" class="result">
          準備填寫抽獎資訊！<img src="img/icon_gift.svg" alt="" />
        </div>
        <div v-else-if="result === 'fail'" class="result fail">
          要不要再檢查一次？
          <img src="img/icon_thinking.svg" alt="" />
        </div>
      </div>
    </div>

    <div class="line full lottery">
      <img src="img/icon_house.svg" alt="" />
      <div>填寫抽獎資訊</div>
    </div>

    <div class="lottery_box">
      <div class="form-group">
        <label for="name">姓名</label>
        <input type="text" :class="['form-control', { error: nameError }]" id="name" placeholder="請輸入姓名"
          v-model="nameValue" @input="nameError = false" :disabled="isSubmitted" />
      </div>

      <div class="form-group">
        <label for="phone">手機號碼</label>
        <input type="text" :class="['form-control', { error: phoneError }]" id="phone" placeholder="請輸入手機號碼"
          v-model="phoneValue" @input="phoneError = false" :disabled="isSubmitted" />
      </div>

      <div class="form-group">
        <label for="email">聯絡Email</label>
        <input type="email" :class="['form-control', { error: emailError }]" id="email" placeholder="請輸入聯絡email"
          v-model="emailValue" @input="emailError = false" :disabled="isSubmitted" />
      </div>

      <div class="btn_box">
        <button class="send_btn" @click="handleSubmit">送出</button>
      </div>

      <!-- 注意事項上移 -->
      <div class="notes_box">
        <ul class="list">
          <li>
            得獎名單預計於<span>115年1月7日(星期三)</span> 在
            <a href="https://taiwanngo.tw/" target="_blank">NGO雙語網站</a>
            公布，另將以電郵通知得獎者；未於通知期限內回覆寄件資訊者，視同放棄得獎資格。
          </li>
          <li>每人限填表一次，重複填寫僅取一次抽獎資格。</li>
          <li>
            若因資料填寫不全導致無法聯繫中獎者，或冒用他人資訊參加，皆視同放棄中獎資格。
          </li>
          <li>
            中獎者需提供證件以證明本人身份，如無法提供完整資訊者，將視同放棄領獎資格。
          </li>
          <li>
            本活動贈品由新客資訊股份有限公司代為執行，獎品寄送以臺、澎、金、馬為限，若中獎者居住於海外，請提供國內代領者的連絡方式。
          </li>
          <li>
            本次活動所蒐集之個人資料，僅限於本次抽獎活動之聯繫、身份驗證及獎品寄送使用。
          </li>
          <li>
            主辦單位保留活動內容、獎品與抽獎名單最終解釋權與變更權利。如遇未盡事宜，得隨時補充公告說明。
          </li>
        </ul>
      </div>

      <!-- 一次性顯示的 div -->
      <div class="message_box">
        <div v-if="showMessage" class="message" ref="targetSection2">
          「感謝您的參與，進一步了解培訓班並免費報名」
          <img src="img/icon_arrow.svg" alt="" />
        </div>
      </div>
    </div>

    <!-- 20251104 新增背景img -->
    <div class="line full activity2">
      <img src="img/icon_rain.svg" alt="" />
      <div></div>
    </div>

    <!-- 20251104 刪掉背景img 刪掉文字區塊(class="text_box") 移入課程說明(class="course_box") -->
    <div class="activity_box activity2_box">
      <!-- <img src="img/icon_rain.svg" alt="" /> -->
      <div></div>

      <div class="activity">
        <div class="title">
          <p>活動二</p>
          <p>報名外交部NGO國際事務人才培訓班 (免費課程)</p>
          <img src="img/icon_leaf.svg" alt="" />
        </div>

        <!-- <div class="text_box">
        <p>
            今年適逢聯合國公布「永續發展目標」(SDGs)十週年，配合外交部總合外交政策，本次培訓班主題為「SDGs十年蛻變－我國NGO總合外交成果與未來展望」，依據SDGs各項指標規劃專題講座及活動，包含學術專業、實務經驗、時事議題及國際事務人才技能等多元內容。
          </p>
        </div> -->

        <div class="course_box">
          <div class="box">
            <div class="bg">
              <div class="title_box">
                <p>【台北場】</p>
              </div>
              <p>
                <span class="small">日期</span>
                <span class="large">114年11月29日</span>
                <span class="small">(星期六)</span>
                <span class="large">至30日</span>
                <span class="small">(星期日)</span>
              </p>
              <p>
                <span class="small">地點</span>
                <span class="large">臺北市立美術館</span>
                <span class="small">(台北市中山區中山北路三段181號)</span>
              </p>

              <!-- 20251104 新增報名按鈕 -->
              <div class="btn_box">
                <a class="register_btn" target="black" href="https://www.accupass.com/event/2510270305387061788050">
                  我要報名
                </a>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="bg">
              <div class="title_box">
                <p>【宜蘭場】</p>
              </div>
              <p>
                <span class="small">日期</span>
                <span class="large">114年12月13日</span>
                <span class="small">(星期六)</span>
                <span class="large">至14日</span>
                <span class="small">(星期日)</span>
              </p>
              <p>
                <span class="small">地點</span>
                <span class="large">宜蘭縣立蘭陽博物館</span>
                <span class="small">(宜蘭縣頭城鎮青雲路三段750號)</span>
              </p>

              <!-- 20251104 新增報名按鈕 -->
              <div class="btn_box">
                <a class="register_btn" target="black" href="https://www.accupass.com/go/114NGO-yilan">
                  我要報名
                </a>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="bg">
              <div class="title_box">
                <p>【嘉義場】</p>
              </div>
              <p>
                <span class="small">日期</span>
                <span class="large">114年12月27日</span>
                <span class="small">(星期六)</span>
                <span class="large">至28日</span>
                <span class="small">(星期日)</span>
              </p>
              <p>
                <span class="small">地點</span>
                <span class="large">國立故宮博物院南部院區</span>
                <span class="small">(嘉義縣太保市故宮大道888號)</span>
              </p>

              <!-- 20251104 新增報名按鈕 -->
              <div class="btn_box">
                <a class="register_btn" target="black" href="https://www.accupass.com/go/114NGO-chiayi">
                  我要報名
                </a>
              </div>
            </div>
          </div>

          <!-- 20251104 新增說明 -->
          <div class="box notes">
            <p>
              如有關於課程內容或報名的任何問題，請聯絡協辦單位天翌管理顧問有限公司潘亭妤（Amber），電話：(02)
              2552-7115；電郵：tianyi.office@gmail.com。
            </p>
          </div>
        </div>
      </div>

      <div></div>
    </div>

    <!-- 20251104 刪除課程資訊 移到class="activity_box activity2_box"裡面 -->
    <!-- <div class="line full course">
      <div>課程資訊</div>
    </div>

    <div class="course_box">
      <div class="box">
        <div class="bg">
          <div class="title_box"><p>【台北場】</p></div>
          <p>
            <span class="small">日期</span>
            <span class="large">114年11月29日</span>
            <span class="small">(星期六)</span>
            <span class="large">至30日</span>
            <span class="small">(星期日)</span>
          </p>
          <p>
            <span class="small">地點</span>
            <span class="large">臺北市立美術館</span>
            <span class="small">(台北市中山區中山北路三段181號)</span>
          </p>
        </div>
      </div>

      <div class="box">
        <div class="bg">
          <div class="title_box"><p>【台中場】</p></div>
          <p>
            <span class="small">日期</span>
            <span class="large">114年12月06日</span>
            <span class="small">(星期六)</span>
            <span class="large">至07日</span>
            <span class="small">(星期日)</span>
          </p>
          <p>
            <span class="small">地點</span>
            <span class="large">國立自然科學博物館</span>
            <span class="small">(台中市北區館前路一號)</span>
          </p>
        </div>
      </div>

      <div class="box">
        <div class="bg">
          <div class="title_box"><p>【嘉義場】</p></div>
          <p>
            <span class="small">日期</span>
            <span class="large">114年12月27日</span>
            <span class="small">(星期六)</span>
            <span class="large">至28日</span>
            <span class="small">(星期日)</span>
          </p>
          <p>
            <span class="small">地點</span>
            <span class="large">國立故宮博物院南部院區</span>
            <span class="small">(嘉義縣太保市故宮大道888號)</span>
          </p>
        </div>
      </div>

      <div class="btn_box">
        <button class="register_btn">我要報名</button>
      </div>
    </div> -->

    <div class="line full notes">
      <img src="img/icon_tree.svg" alt="" />
      <div></div>
    </div>
    <!-- <div class="line full notes">
      <img src="img/icon_tree.svg" alt="" />
      <div>活動注意事項</div>
    </div> -->

    <div class="footer_box">
      <p>
        外交部非政府組織國際事務會
        <br />
        外交部地址：100202 臺北市凱達格蘭大道二號
        <br />
        <!-- 外交部NGO雙語網站專線：02-2348-2231（週一至週五上班時間9:00-18:00） -->
        <!-- <br /> -->
        聯絡電郵：taiwanngo@gmail.com
      </p>
    </div>

  </div>
</template>
<script>
export default {
  name: "Home",
  components: {
  },
  data() {
    return {
      // 標題
      fullText: "114年外交部NGO國際事務人才培訓班",
      fullText2: "「總合外交政策下我國NGO的國際參與成果與展望」",
      title_1: "",
      title_2: "",
      currentIndex: 0,
      currentIndex2: 0,

      // 測驗問題
      questions: [
        {
          text: "當前外交部推行的外交政策是？",
          options: ["全民外交", "整體外交", "總合外交", "總體外交"],
          answer: "總合外交",
          hint: "活動一的活動說明",
        },
        {
          text: "以下哪一個「不是」今年外交部NGO國際事務人才培訓班舉辦地點",
          options: [
            "國立臺灣科學教育館",
            "宜蘭縣立蘭陽博物館",
            "臺北市立美術館",
            "國立故宮博物院南部院區",
          ],
          answer: "國立臺灣科學教育館",
          hint: "參考第4題題目",
        },
        {
          text: "聯合國於哪一年公布「永續發展目標（SDGs）」？",
          options: ["2000年", "2015年", "2020年", "2024年"],
          answer: "2015年",
          hint: "活動一的活動說明",
        },
        {
          text: "對國際事務交流有興趣的你，想參加哪一場課程呢？",
          options: [
            "11/29-11/30 台北場-臺北市立美術館",
            "12/13-12/14 宜蘭場-宜蘭縣立蘭陽博物館",
            "12/27-12/28 嘉義場-國立故宮博物院南部院區",
          ],
          acceptAll: true,
          hint: "任選一場課程",
        },
      ],
      userAnswers: ["", "", "", ""], // 儲存每題的使用者答案
      result: "", // success / fail / ''

      activeHint: null, // 哪一題的提示正在顯示
      typedHint: "", // 正在輸出的提示文字
      typingInterval: null, // 打字動畫的 interval 控制
      hintWidth: 0, // 寬度

      // 填寫抽獎
      nameValue: "",
      phoneValue: "",
      emailValue: "",
      showMessage: false,
      nameError: false,
      phoneError: false,
      emailError: false,
      isSubmitted: false, // 新增：送出後欄位禁用
    };
  },

  watch: {
    // 測驗問題
    userAnswers: {
      handler(val) {
        // 確保三題都有選
        if (val.every((ans) => ans !== "")) {
          //this.checkAnswers();
        } else {
          this.result = ""; // 還沒選完先清掉結果
        }
      },
      deep: true,
    },
  },
  mounted() {
    // 標題跑字延遲
    setTimeout(this.typeWriter, 0);
    setTimeout(this.typeWriter2, 800);
  },
  methods: {
    //  標題跑字
    typeWriter() {
      if (this.currentIndex < this.fullText.length) {
        this.title_1 += this.fullText[this.currentIndex];
        this.currentIndex++;
        setTimeout(this.typeWriter, 90); // 每個字間隔 100 毫秒
      }
    },
    typeWriter2() {
      const step = 2; // 每次加幾個字
      if (this.currentIndex2 < this.fullText2.length) {
        this.title_2 += this.fullText2.slice(
          this.currentIndex2,
          this.currentIndex2 + step
        );
        this.currentIndex2 += step;
        setTimeout(this.typeWriter2, 120); // 每個字間隔 100 毫秒
      }
    },

    // 點擊下滑
    scrollToSection() {
      const target = this.$refs.targetSection;
      if (target) {
        const offsetTop = target.offsetTop;
        window.scrollTo({
          top: offsetTop - 100, // 減去 header 高度（如需）
          behavior: "smooth",
        });
      }
    },

    // getLetter(index) {
    //   // 取得 A-Z（index 從 0 開始）
    //   return String.fromCharCode(65 + index);
    // },

    // 測驗問題的小提示
    showHint(index) {
      // 1. 清除前一次動畫
      clearInterval(this.typingInterval);
      clearTimeout(this.hideHintTimeout);

      // 2. 準備資料
      const fullHint = this.questions[index].hint;
      const typingSpeed = 50;
      const delayBeforeCharAppears = 100; // 框展開後多久再顯示字
      const initialDelay = 500;
      const readDelay = 2000;

      // 3. 初始化狀態
      this.activeHint = index;
      this.typedHint = "";
      this.hintWidth = 32;

      // 4. 用區域變數保存目前已打字的內容，避免非同步互搶
      let currentHint = "";

      // 5. 排程每個字的寬度 + 顯示
      fullHint.split("").forEach((char, i) => {
        const timeOffset = initialDelay + i * typingSpeed;

        setTimeout(() => {
          currentHint += char; // 加入新字（在區域變數）

          // 計算新寬度
          this.hintWidth = currentHint.length * 16 + 50;

          // 等框展開後再顯示這個字
          setTimeout(() => {
            this.typedHint = currentHint;
          }, delayBeforeCharAppears);
        }, timeOffset);
      });

      // 6. 結束後自動清除
      const typingDuration =
        fullHint.length * typingSpeed + delayBeforeCharAppears;
      const totalVisibleTime = initialDelay + typingDuration + readDelay;

      this.hideHintTimeout = setTimeout(() => {
        this.activeHint = null;
        this.typedHint = "";
        this.hintWidth = 32;
      }, totalVisibleTime);
    },

    // 測驗問題
    handleChange() {
      // 若未選完，清除結果
      if (!this.userAnswers.every((ans) => ans !== "")) {
        this.result = "";
        return;
      }

      // 計算正確題數
      const correctCount = this.questions.reduce((count, question, index) => {
        const userAnswer = this.userAnswers[index];

        if (question.acceptAll) {
          return count + 1; // 此題任意都對
        }

        return count + (userAnswer === question.answer ? 1 : 0);
      }, 0);

      // 判斷是否全部正確
      this.result = correctCount === this.questions.length ? "success" : "fail";
    },

    // 填寫抽獎
    async handleSubmit() {
      // 去除空白後檢查是否為空
      const nameIsEmpty = this.nameValue.trim() === "";
      const phoneIsEmpty = this.phoneValue.trim() === "";
      const emailIsEmpty = this.emailValue.trim() === "";
      // 根據驗證結果設定錯誤 class 控制變數
      this.nameError = nameIsEmpty;
      this.phoneError = phoneIsEmpty;
      this.emailError = emailIsEmpty;

      // 如果有任何欄位為空，停止執行
      if (nameIsEmpty || phoneIsEmpty || emailIsEmpty) {
        this.$swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '請填寫所有欄位後再試一次',
          confirmButtonText: '確定'
        });
        return;
      }

      try {
        // 顯示載入中
        this.$swal.fire({
          title: '送出中',
          text: '請稍候...',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 等待 reCAPTCHA 載入完成
        await this.$recaptchaLoaded();

        // 執行 reCAPTCHA 驗證並取得 token
        const recaptchaToken = await this.$recaptcha('submit_form');

        let that = this;
        $.ajax({
          type: 'post',
          url: 'https://taiwanngo.tw/Event2025Send',
          data: {
            name: that.nameValue.trim(),
            phone: that.phoneValue.trim(),
            email: that.emailValue.trim(),
            question1: that.userAnswers[0],
            question2: that.userAnswers[1],
            question3: that.userAnswers[2],
            question4: that.userAnswers[3],
            captcha: recaptchaToken,
          },
          success: function (result) {
            if (result.ok) {
              that.$swal.fire({
                title: "成功",
                text: "已成功送出, 感謝您的填寫!您的填寫順序為:" + result.Number,
                icon: "success",
                confirmButtonText: "確　　認",
                didClose: () => {
                  that.showMessage = true;
                  that.isSubmitted = true;
                  // 顯示訊息後下滑
                  that.$nextTick(() => {
                    const target = that.$refs.targetSection2;
                    if (target) {
                      const offsetTop =
                        target.getBoundingClientRect().top + window.pageYOffset;
                      const offset = offsetTop - 200;
                      window.scrollTo({
                        top: offset,
                        behavior: "smooth",
                      });
                    }
                  });
                }
              });
            } else if (result.error) {
              that.$swal.fire({
                icon: "error",
                title: "錯誤",
                text: result.error,
                confirmButtonText: "確　　認"
              });
            } else {
              that.$swal.fire({
                icon: "error",
                title: "發生錯誤，請聯絡資訊人員。",
                html: result,
                confirmButtonText: "確　　認"
              });
            }
          },
          error: function (xhr, status, error) {
            that.$swal.fire({
              icon: "error",
              title: "網路錯誤",
              text: "請檢查網路連線後再試一次",
              confirmButtonText: "確　　認"
            });
          }
        });
      } catch (error) {
        console.error('Submit error:', error);

        // 判斷是否為 reCAPTCHA 相關錯誤
        if (error.message && error.message.includes('recaptcha')) {
          this.$swal.fire({
            icon: "error",
            title: "驗證失敗",
            text: "reCAPTCHA 驗證發生錯誤，請重新整理頁面後再試一次",
            confirmButtonText: "確　　認"
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "發生錯誤，請聯絡資訊人員。",
            text: "請稍後再試一次",
            confirmButtonText: "確　　認"
          });
        }
      }
    },
  },
};
</script>
